var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaptop({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.327,
    height: 27.551,
    viewBox: "0 0 41.327 27.551",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "laptop",
    transform: "translate(0 -85.333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_965",
    "data-name": "Group 965",
    transform: "translate(0 85.333)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4643",
    "data-name": "Path 4643",
    d: "M40.466,107.719H37.883V88.777a3.447,3.447,0,0,0-3.444-3.444H6.888a3.447,3.447,0,0,0-3.444,3.444v18.942H.861A.86.86,0,0,0,0,108.58v.861a3.447,3.447,0,0,0,3.444,3.444H37.883a3.447,3.447,0,0,0,3.444-3.444v-.861A.86.86,0,0,0,40.466,107.719ZM5.166,88.777a1.724,1.724,0,0,1,1.722-1.722H34.439a1.724,1.724,0,0,1,1.722,1.722v18.942h-31Zm32.717,22.386H3.444a1.724,1.724,0,0,1-1.722-1.722H16l.609.609a.86.86,0,0,0,.609.252h6.888a.86.86,0,0,0,.609-.252l.609-.609h14.28A1.724,1.724,0,0,1,37.883,111.162Z",
    transform: "translate(0 -85.333)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptop);
export default __webpack_public_path__ + "static/media/laptop.e220b8501480c517fccd229343722d8e.svg";
export { ForwardRef as ReactComponent };